import { Link } from "react-router";
import { AuthLayout } from "../components/AuthLayout";

export function NotFoundPage() {
  return (
    <AuthLayout title="Page not found">
      <p className="muted">That page doesn't exist.</p>
      <Link to="/">Go home</Link>
    </AuthLayout>
  );
}
